import { updateQueryString } from './includes/shared/utils.js';
import { elements } from './includes/fundingDecisions/elements.js';
import { preloadFormFields } from './includes/fundingDecisions/preloadFormFields.js';
import { fetchResults } from './includes/fundingDecisions/fetchResults.js';
import { bindFormElements } from './includes/fundingDecisions/bindFormElements.js';
import { initializeExpandableFilter } from '../includes/collapseFilterGroup.js';

const isFundingDecisionsPage = () => {
    return !!elements.searchForm && !!elements.resultsContainer;
};

export const initializeSearchFundingDecisions = () => {
    if (!isFundingDecisionsPage()) return;

    const { allChoices } = preloadFormFields();
    bindFormElements(fetchResults, updateQueryString, allChoices);
    fetchResults();
    initializeExpandableFilter(elements.expandFilterButton, elements.expandableFilter);
};
